import logo from "./media/logo.png";
import logoPost from "./media/logoPost.png";
import ceLogo from "./media/ce.png";
import backgroundImage from "./media/background.jpg";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "actiway",
  image: logo,
  imagePost: logoPost,
  imageQA: logoPost,
  ceLogo: ceLogo,
  backGroundVideo: null,
  appBackground: {
    url: backgroundImage
  },
  secondaryBackground: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    gradientColors: ["rgba(255, 255, 255, 0.9)", "rgba(255, 255, 255, 0.8)"]
  },
  footerImage: footerLogo,
  baseClass: "brand-actiway",
  domains: [
    "http://localhost:4004",
    "https://dev-actiway.healo.app",
    "https://stg-actiway.healo.app",
    "https://actiway.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1139 : 1102,
  ssnEnabled: true,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/actiway/settings.js